// extracted by mini-css-extract-plugin
export default {"labeledSwitch":"labeled-switch_labeledSwitch__GivKs","label":"labeled-switch_label__j9bv5"};